// /apply entry surface. Reachable from Landing's "Request early access"
// door, or directly. Public — no auth state.
import { ApplyForm } from "./ApplyForm";
import { CloudMast } from "./CloudMast";
import { DEFAULT_SERVER, SERVER_STORAGE_KEY } from "../lib/server-config";


function resolveServer(): string {
  try {
    const stored = localStorage.getItem(SERVER_STORAGE_KEY);
    if (stored) return stored;
  } catch {
    // localStorage unavailable
  }
  if (typeof window !== "undefined") {
    const host = window.location.hostname;
    if (host === "localhost" || host === "127.0.0.1") {
      return window.location.origin;
    }
  }
  return DEFAULT_SERVER;
}


export function ApplyShell() {
  const server = resolveServer();
  return (
    <main className="landing">
      <div className="landing-wrap">
        <CloudMast brandHref="/" />

        <section className="apply-section">
          <div className="apply-intro">
            <div className="apply-intro-head">
              <div className="landing-eyebrow">Request early access</div>
              <h1 className="landing-title">
                Tell us a little about your situation.
              </h1>
            </div>
            <div className="apply-intro-body">
              <p className="landing-lede">
                Aurora is in early access, and we set up each person
                directly. Tell us the basics and a real person will email
                you to talk through what you need and get you set up — no
                automated approvals. Sponsored access for those who
                qualify; a flat fee per analysis otherwise. Nothing here
                is&nbsp;shared.
              </p>
            </div>
          </div>

          <div className="apply-card">
            <ApplyForm server={server} />
          </div>
        </section>

        <footer className="landing-foot">
          <div className="landing-foot-left" />
          <div className="landing-foot-right">&copy; 2026 Aurora</div>
        </footer>
      </div>
    </main>
  );
}
